import CustomersMain from "../components/customers/CustomersMain";

function Customers() {
  return <CustomersMain />;
}

export default Customers;
